import { MovementType, MovementTypePost, MovementTypePut } from '../interfaces/MovementType';
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class MovementTypeApi {
    static async searchMovementType(params: MovementType) {
        var response = await ApiHandler(baseURL).get('MovementType/search', { params });
        return response.data;
    }

    static async getMovementType(id: number) {
        var response = await ApiHandler(baseURL).get(`MovementType/${id}`);
        return response.data;
    }

    static async postMovementType(post: MovementTypePost) {
        var response = await ApiHandler(baseURL).post('MovementType', post);
        return response.data;
    }

    static async putMovementType(put: MovementTypePut) {
        var response = await ApiHandler(baseURL).put('MovementType', put);
        return response.data;
    }

    static async deleteMovementType(id: number) {
        var response = await ApiHandler(baseURL).delete(`MovementType/${id}`);
        return response.data;
    }
}
